export const apiTokenList = [
  {
    key: "baidu7",
    apiToken: "TRixfpKwzuOPQtlL4f7O03mO4lRrrm17@w30YEWvRKYEGqNRppBS7lITCzpUygnA3"
  },
  {
    key: "yueke",
    apiToken: "0tY8XRmfG9VHZgVdZ2tgmpIzE46q3znZ@IEq8paW74P6q30zxCpRAwOArFl1NzfeZ"
  },
  {
    key: "xywl777",
    apiToken: "h67GNF78a6RN7GsRluBGeZxjvaQ8Hs3M@yoqOtOgyTqZdOjY3kGBWpqMhHAPsSSuu"
  },
  {
    key: "91wll",
    apiToken: "LSNYsZQiTgFzk5UsesdaEaVFde27qYsn@dQQ1OrMQbrk6ZObhn7SeZcXT2Poe7Eh7"
  },
]
